"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledRadioPropType = exports.StyledRadioInputProps = exports.StyledRadioInput = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _Icon = require("../../../../UIElements/Icons/PetSure/Icon");
var _hooks = require("../../../../../hooks");
var _validationPropType = require("../../../../../propTypes/validationPropType");
const _excluded = ["fieldFormContext", "validation", "value", "radioInput", "groupName", "onChange", "customCssClassPrefix", "isOnlyOption", "customTrackingData", "customTrackingEvents"],
  _excluded2 = ["ref"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const StyledRadioInput = _ref => {
  let {
      fieldFormContext,
      validation,
      value,
      radioInput,
      groupName,
      onChange,
      customCssClassPrefix,
      isOnlyOption = false,
      customTrackingData,
      customTrackingEvents
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const hookFormContext = (0, _reactHookForm.useFormContext)();
  const formContext = fieldFormContext || hookFormContext;
  const {
    register
  } = formContext || {
    register: () => {
      return {
        ref: () => {}
      };
    }
  };
  const fieldElement = (0, _react.useRef)(null);
  const fieldState = formContext && formContext.getFieldState(groupName);
  const [isChecked, setIsChecked] = (0, _react.useState)(value === radioInput.value);
  (0, _react.useEffect)(() => {
    setIsChecked(value === radioInput.value);
    if (formContext && formContext.setValue) {
      formContext.setValue(groupName, value);
    }
  }, [setIsChecked, value, radioInput.value, formContext, groupName]);
  const handleRadioSelect = selectedValue => {
    setIsChecked(true);
    if (onChange) {
      onChange(selectedValue);
    }
  };
  const hasGraphic = radioInput.imageUrl;
  const hasIcon = typeof radioInput.icon !== 'undefined';
  const hasIconGraphic = typeof radioInput.iconGraphic !== 'undefined';
  const customLabelCssClass = customCssClassPrefix ? "".concat(customCssClassPrefix, "RadiosInput") : '';
  const labelText = radioInput.label && radioInput.label.checked ? radioInput.label.checked.toLowerCase() : radioInput.label.toLowerCase();
  const graphicCssClass = "radioGraphic radioGraphic_".concat(labelText);
  const graphicStyle = radioInput.imageUrl !== '' ? {
    backgroundImage: "url(".concat(radioInput.imageUrl, ")")
  } : {};
  const getInputId = () => {
    if (radioInput.id) {
      return radioInput.id;
    }
    if (radioInput.label.checked || radioInput.label.unchecked) {
      return "".concat(groupName, "_").concat(value);
    }
    const labelWithoutChars = labelText.replace(/[^a-zA-Z0-9]/g, '');
    return "".concat(groupName, "_").concat(labelWithoutChars.toLowerCase());
  };
  const getIcon = () => {
    if (!hasIcon) {
      return null;
    }
    if (radioInput.icon) {
      if (radioInput.icon.checked || radioInput.icon.unchecked) {
        if (isChecked) {
          if (typeof radioInput.icon.checked === 'string') {
            return /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
              icon: radioInput.icon.checked
            });
          }
          return radioInput.icon.checked;
        }
        if (typeof radioInput.icon.checked === 'string') {
          return /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
            icon: radioInput.icon.unchecked
          });
        }
        return radioInput.icon.unchecked;
      }
      if (typeof radioInput.icon === 'string') {
        return /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
          icon: radioInput.icon
        });
      }
      return radioInput.icon;
    }
    return /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: labelText
    });
  };
  const getIconGraphic = () => {
    if (typeof radioInput.iconGraphic === 'string') {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "iconGraphic",
        style: {
          backgroundImage: "url(".concat(radioInput.iconGraphic, ")")
        }
      });
    }
    return radioInput.iconGraphic;
  };
  const getLabel = () => {
    if (radioInput.label && radioInput.label.checked) {
      return isChecked ? radioInput.label.checked : radioInput.label.unchecked;
    }
    return radioInput.label;
  };
  const getLabelCssClass = () => {
    if (hasGraphic) {
      return 'sr-only';
    }
    let labelTextCssClass = 'labelText';
    if (hasIconGraphic) {
      labelTextCssClass += ' labelTextIconGraphic';
    }
    if (radioInput.labelCssClass) {
      if (typeof radioInput.labelCssClass === 'string') {
        labelTextCssClass = radioInput.labelCssClass;
      }
      if (radioInput.labelCssClass.checked && isChecked) {
        labelTextCssClass = radioInput.labelCssClass.checked;
      }
      if (radioInput.labelCssClass.unchecked && !isChecked) {
        labelTextCssClass = radioInput.labelCssClass.unchecked;
      }
    }
    return "radioLabel ".concat(labelTextCssClass);
  };
  (0, _hooks.useTracking)({
    elementRef: fieldElement,
    trackingProps: {
      label: labelText,
      field: {
        fieldState: fieldState || {},
        inputType: 'radio',
        name: groupName,
        id: radioInput.id || value
      }
    },
    customTrackingData,
    customTrackingEvents
  });
  const _register = register(groupName, _objectSpread({}, validation)),
    {
      ref: hookFormRef
    } = _register,
    hookFormRegistration = _objectWithoutProperties(_register, _excluded2);
  return /*#__PURE__*/_react.default.createElement("label", {
    className: "radioInput ".concat(customLabelCssClass)
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    onClick: () => handleRadioSelect(radioInput.value),
    type: "radio",
    defaultValue: radioInput.value,
    defaultChecked: isChecked || isOnlyOption,
    disabled: isOnlyOption,
    name: groupName,
    id: getInputId()
  }, hookFormRegistration, {
    ref: e => {
      hookFormRef(e);
      fieldElement.current = e;
    }
  }, rest)), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(getLabelCssClass()).concat(fieldState !== null && fieldState !== void 0 && fieldState.invalid ? ' invalidField' : '')
  }, getIcon(), getIconGraphic(), /*#__PURE__*/_react.default.createElement("span", {
    className: "text"
  }, getLabel())), hasGraphic && /*#__PURE__*/_react.default.createElement("span", {
    className: graphicCssClass,
    title: radioInput.label
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "imageHolder",
    style: graphicStyle
  })));
};
exports.StyledRadioInput = StyledRadioInput;
const StyledRadioPropType = exports.StyledRadioPropType = _propTypes.default.shape({
  id: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    checked: _propTypes.default.string,
    unchecked: _propTypes.default.string
  })]),
  labelCssClass: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    checked: _propTypes.default.string,
    unchecked: _propTypes.default.string
  })]),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
  imageUrl: _propTypes.default.string,
  imageIcon: _propTypes.default.string,
  icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    checked: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
    unchecked: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element])
  }), _propTypes.default.element]),
  iconGraphic: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element])
});
const StyledRadioInputProps = exports.StyledRadioInputProps = {
  // eslint-disable-next-line react/forbid-prop-types
  fieldFormContext: _propTypes.default.any,
  validation: _propTypes.default.shape(_validationPropType.ValidationPropType),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
  radioInput: StyledRadioPropType,
  groupName: _propTypes.default.string,
  onChange: _propTypes.default.func,
  customCssClassPrefix: _propTypes.default.string,
  isOnlyOption: _propTypes.default.bool,
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string),
  // eslint-disable-next-line react/forbid-prop-types
  rest: _propTypes.default.any
};
StyledRadioInput.propTypes = StyledRadioInputProps;
var _default = exports.default = {
  StyledRadioInput,
  StyledRadioInputProps,
  StyledRadioPropType
};